(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["farana-promo-banner"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-farana-promo]').forEach(bar=>{try{bar.hidden=sessionStorage.getItem('farana-duo-offer-v2')==='closed'}catch(e){}bar.querySelector('[data-promo-close]').addEventListener('click',()=>{bar.hidden=true;try{sessionStorage.setItem('farana-duo-offer-v2','closed')}catch(e){}const main=document.querySelector('main');if(main){main.setAttribute('tabindex','-1');main.focus({preventScroll:true})}})});
  } catch(e) { console.error(e); }
})();

})();
